export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10070.e0579800.jpg";